import React, { ReactNode, useMemo } from "react";
import Image from "next/image";
import classes from "./PreviewMobileBox.module.scss";
import { AiOutlineInfoCircle } from "react-icons/ai";
type TPreviewMobileBox = {
  renderSvg: ReactNode;
  isLoading: boolean;
  qrfast?: boolean;
};
export const PreviewMobileBox: React.FC<TPreviewMobileBox> = ({
  renderSvg,
  isLoading,
  qrfast = false
}) => {
  const QR = useMemo(() => isLoading ? <div className={classes.loader}>
          <Image src={"/home-page/loadereffect.svg"} alt="loader effect" width={100} height={100} />
          <div className={classes.loaderEffect}></div>
        </div> : renderSvg, [renderSvg, isLoading]);
  return <div className={classes.PreviewBox} data-sentry-component="PreviewMobileBox" data-sentry-source-file="PreviewMobileBox.tsx">
      <div className={classes.PreviewBoxTitle}>
        <AiOutlineInfoCircle color={qrfast ? "#aa00fd" : "#616568"} size={16} data-sentry-element="AiOutlineInfoCircle" data-sentry-source-file="PreviewMobileBox.tsx" />
      </div>
      <div className={classes.SvgMobileBox}>{QR}</div>
    </div>;
};